import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import { Skeleton } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function ModalDifferentParentWG() {
  const { t } = useTranslation();

  const {
    WGBingoID,
    updateTransactions,
    updateIsLimitSurpassed,
    updateShowIsLimitSurpassed,
    updateIsMonthlyLimitSurpassed,
    updateMaxAllowed,
    updateShowIsLimitSurpassedTransaction,
    updateIsDailyLimitSurpassed,
    updateCurrentTicketWG,
    printer,
    updateIsTerminalBusy,
    updateIsLoadingScreen,
    adoptedTicket,
    parentInfo,
    updateAdoptedTicket,
    session,
    updateFocusOnMainScreen,
    userInfo,
    operator,
    hall,
    openSessionTerminal,
    updateOpenSessionTerminal,
    updateShowModalDifferentParentWG,
    updateTransactionsArray,
    ticketsWG,
    currentTicketWG,
    updateTicketsWG,
    updateTicketsWGWithNewSaldo,
  } = useContext(AppContext);

  const WGBingoIDRef = useRef(WGBingoID);
  useEffect(() => {
    WGBingoIDRef.current = WGBingoID;
  }, [WGBingoID]);

  const [isTerminalBusy, setIsTerminalBusy] = useState(false);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState(0);
  const [ticket, setTicket] = useState({});
  const [isClosed, setIsClosed] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (!loading) {
      updateIsLoadingScreen(false);
    }
  }, [loading]);

  //* REFS
  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const operatorRef = useRef(operator);
  useEffect(() => {
    operatorRef.current = operator;
  }, [operator]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const adoptedTicketRef = useRef(adoptedTicket);
  useEffect(() => {
    adoptedTicketRef.current = adoptedTicket;
  }, [adoptedTicket]);

  const amountRef = useRef(amount);
  useEffect(() => {
    amountRef.current = amount;
  }, [amount]);

  const printerRef = useRef(printer);
  useEffect(() => {
    printerRef.current = printer;
  }, [printer]);

  const [wgTicketID, setWgTicketID] = useState(false);
  const wgTicketIDRef = useRef(wgTicketID);
  useEffect(() => {
    wgTicketIDRef.current = wgTicketID;
  }, [wgTicketID]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  //* Recover all the info
  useEffect(() => {
    socket.emit('ticketsWG', {
      operator: operator,
      bingoName: hall,
      userID: adoptedTicket.parent.id,
      userInfo: adoptedTicket.parent,
      session: session,
      action: 'ticketsWG',
      WGBingoID: WGBingoID,
    });
  }, []);

  useEffect(() => {
    console.log('currentTicketWG', currentTicketWG);
    if (!currentTicketWG) {
      return;
    }

    setAmount(currentTicketWG.currentBalance);
    setIsClosed(currentTicketWG.isCashedOut);
    setLoading(false);
    if (!currentTicketWG.isCashedOut && !currentTicketWG.isInUse) {
      setIsDisabled(false);
    }
  }, [currentTicketWG]);

  useEffect(() => {
    const handleCashoutWG = (data) => {
      if (!data) {
        toast.error(t('error.error'));
        updateIsTerminalBusy(false);
        updateIsLoadingScreen(false);

        return;
      }
      updateTransactions({
        name: 'Utbetaling' + ' - ' + 'WG',
        //amount: parseInt(amount),
        amount: parseInt(amountRef.current) * -1,
        type: 'transaction',
        ticketData: data,
      });

      updateCurrentTicketWG(false);

      setTimeout(() => {
        updateIsLoadingScreen(false);
        updateShowModalDifferentParentWG(false);
        updateIsTerminalBusy(false);
        if (parentInfoRef.current) {
          socket.emit('checkLimitStatus', {
            userInfo: parentInfoRef.current,
            bingoName: hallRef.current,
          });
        } else {
          socket.emit('checkLimitStatus', {
            userInfo: userInfoRef.current,
            bingoName: hallRef.current,
          });
        }
      }, 300);
    };

    socket.on('cashoutWG', handleCashoutWG);

    return () => {
      socket.off('cashoutWG', handleCashoutWG);
    };
  }, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const handlePayOut = async () => {
    updateIsTerminalBusy(true);
    updateIsLoadingScreen(true);
    if (isTerminalBusy) {
      return;
    }
    socket.emit('cashoutWG', {
      operator: operator,
      bingoName: hall,
      sessionID: sessionRef.current,
      userInfo: parentInfo ? parentInfo : userInfo,
      amount: parseInt(amountRef.current),
      provider: 'WG',
      description: 'Utbetaling',
      wgID: currentTicketWG.wgID,
      action: 'cashoutWG',
      printer: printer,
      bingoID: WGBingoIDRef.current,
      isAdopted: true,
    });
  };

  const cancel = async () => {
    updateOpenSessionTerminal(false);
    updateAdoptedTicket({});
    updateFocusOnMainScreen(true);
    updateShowModalDifferentParentWG(false);
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>{t('sales.ticketWithDifferentParentTitle')} </h1>

            {!loading ? (
              <>
                {isClosed && (
                  <p
                    style={{
                      fontSize: '22px',
                      color: '#42a5f5',
                      fontWeight: 'bold',
                    }}
                  >
                    {t('sales.ticketClosedOK')}.
                  </p>
                )}

                {!currentTicketWG.isCashedOut && (
                  <>
                    <p>{t('sales.ticketWithDifferentParentText')}</p>
                    <p>
                      {t('sales.currentSaldo')}:{' '}
                      <span
                        style={{
                          fontSize: '22px',
                          color: '#42a5f5',
                          fontWeight: 'bold',
                        }}
                      >
                        {amount + ' kr.'}
                      </span>
                    </p>
                  </>
                )}

                {currentTicketWG.isInUse && (
                  <p
                    style={{
                      fontSize: '22px',
                      color: '#42a5f5',
                      fontWeight: 'bold',
                    }}
                  >
                    {t('sales.wgTicketInUse')}.
                  </p>
                )}
              </>
            ) : (
              <>
                <Skeleton
                  sx={{ bgcolor: 'grey.500' }}
                  style={{
                    height: '75px',
                  }}
                />
                <Skeleton
                  sx={{ bgcolor: 'grey.500' }}
                  style={{
                    height: '75px',
                  }}
                />
                <Skeleton
                  sx={{ bgcolor: 'grey.500' }}
                  style={{
                    height: '175px',
                  }}
                />
              </>
            )}

            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: '55px' }}
            >
              {!currentTicketWG.isCashedOut && !currentTicketWG.isInUse && (
                <button
                  className="btn-custom-yes"
                  onClick={() => {
                    if (!amount || amount === 0) {
                      return;
                    }
                    if (loading) {
                      return;
                    }
                    handlePayOut();
                  }}
                  style={{
                    opacity: loading || !amount || amount === 0 ? 0.5 : 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px', // Space between icon and text
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                  {t('sales.confirm')}
                </button>
              )}

              <button
                className="btn-custom-no"
                style={{
                  opacity: loading ? 0.5 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
                onClick={() => {
                  if (loading) {
                    return;
                  }
                  cancel();
                }}
              >
                <CancelIcon style={{ fontSize: '1.2em' }} />

                {t('sales.cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalDifferentParentWG;
